import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";

import { AppDispatch, AppStore, RootState } from "~/store";

// Use throughout your app instead of plain `useDispatch`, `useSelector` and `useStore`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = useStore.withTypes<AppStore>();
